import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksTimeItem.module.scss';

interface Props {
  className?: string;
  date?: string;
  startTime: string;
  endTime: string;
  instructors?: string[];
  withPadding?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const BooksTimeItem = ({
  className,
  date,
  startTime,
  endTime,
  intl,
  instructors,
  withPadding,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(
    css.BooksTimeItem,
    { [css.withPadding]: withPadding },
    className,
  );

  return (
    <div className={classes} onClick={onClick}>
      {date && (
        <span className={css.BooksTimeItem__Date}>
          {intl.formatDate(df.format(date), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
          })}
        </span>
      )}
      {
        // TODO: 組み込み時にtimezoneを考慮すること。
      }
      <span className={css.BooksTimeItem__Time}>
        {startTime}
        <span> - </span>
        {endTime}
      </span>
      {instructors && instructors.length > 0 && (
        <span className={css.BooksTimeItem__Instructor}>
          {intl.formatMessage({ id: 'books.forms.staff' })}:
          {instructors.map((instructor, i) => (
            <span className={css.BooksTimeItem__InstructorName} key={i}>
              {instructor}
            </span>
          ))}
        </span>
      )}
    </div>
  );
};

export default injectIntl(BooksTimeItem);
